import type { FunctionComponent, HTMLAttributes } from 'react';

import type { VolumeControlType } from '../../../store/slices/settings/hooks/useVolumeControl';
import { IconButton, Icons } from '../iconButton/IconButton';
import { RangeInput } from '../rangeInput/RangeInput';
import { Toggle } from '../toggle/Toggle';

import styles from './volumeSlider.module.css';

export interface VolumeSliderProps extends HTMLAttributes<HTMLDivElement> {
  control: VolumeControlType;
  noVolumeControl?: boolean;
  disabled?: boolean;
  masterVolume?: number;
  allIsMuted?: boolean;
}

const handleClick = (handler: () => void, disabled: boolean): void => {
  if (!disabled) {
    handler();
  }
};

export const VolumeSlider: FunctionComponent<VolumeSliderProps> = ({
  control,
  disabled,
  masterVolume,
  allIsMuted,
  noVolumeControl,
  ...rest
}) => {
  const { value, toggle, unmuteVideo, change, temporaryChange } = control;

  if (noVolumeControl) {
    return (
      <div className={styles.volumeSlider} {...rest}>
        <Toggle
          disabled={disabled}
          checked={value > 0 && masterVolume !== undefined && masterVolume > 0}
          onChange={(event) => change(event.target.checked ? 1 : 0)}
        />
      </div>
    );
  } else {
    const disableSlider = (masterVolume === 0 && !allIsMuted) || (disabled ? disabled : false);
    return (
      <div className={styles.volumeSlider} {...rest}>
        <IconButton
          ghost
          icon={value > 0 ? Icons.SoundOn : Icons.SoundOff}
          onClick={(): void => {
            toggle();
            handleClick(unmuteVideo, disableSlider);
          }}
          disabled={disableSlider}
        />
        <div className={styles.volumeSlider__sliderContainer}>
          <RangeInput
            min={0}
            max={1}
            step={0.1}
            value={value}
            onClick={(): void => {
              handleClick(unmuteVideo, disableSlider);
            }}
            onDrag={(newValue): void => {
              temporaryChange(newValue);
            }}
            onChange={(newValue): void => {
              change(newValue);
            }}
            disabled={disableSlider}
          />
        </div>
      </div>
    );
  }
};
